/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Planning_Vakanties_Vervallen_DagenInputs */

const nl_planning_vakanties_vervallen_dagen = /** @type {(inputs: Planning_Vakanties_Vervallen_DagenInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Op die dagen vervalt 1 gymles uit het rooster.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Op die dagen vervallen ${i?.count} gymlessen uit het rooster.`);
	return /** @type {LocalizedString} */ ("planning.vakanties.vervallen_dagen");
};

/**

* @param {Planning_Vakanties_Vervallen_DagenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_vervallen_dagen = /** @type {((inputs: Planning_Vakanties_Vervallen_DagenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Vervallen_DagenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_vervallen_dagen(inputs)
});
export { planning_vakanties_vervallen_dagen as "planning.vakanties.vervallen_dagen" }